"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandSection = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const context_1 = require("./context");
const ContextItem_1 = require("../ContextItem");
const Code_1 = require("../../../1-inline/Code");
const Iconista_1 = require("../../../icons/Iconista");
const ContextTitleNested_1 = require("../ContextTitleNested");
const Flex_1 = require("../../../3-list-item/Flex");
const util_1 = require("./util");
const ExpandSection = (props) => {
    const { path, menu, child, renderItem, renderPane, open, onTitleMouseEnter, onTitleMouseLeave, onTitleMouseMove } = props;
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useContextMenu)();
    const [all, setAll] = React.useState(child.expand === (child.children?.length ?? 0) - 1);
    const nodes = [];
    const subChildren = child.children;
    if (!subChildren)
        return null;
    const expand = child.expand;
    if (!expand)
        return null;
    const bigIcons = (0, util_1.bigIconsState)(nodes, menu);
    for (let j = 0; j < subChildren.length && j < (all ? 1000 : expand); j++) {
        const subChild = subChildren[j];
        if (subChild.sep || subChild.sepBefore) {
            bigIcons.flush();
            const key = subChild.id ?? subChild.name;
            nodes.push((0, util_1.line)(key, true));
            if (!subChild.sepBefore)
                continue;
        }
        if (subChild.iconBig)
            bigIcons.push(subChild);
        else {
            bigIcons.flush();
            nodes.push(renderItem(subChild));
        }
    }
    bigIcons.flush(false);
    let remaining = subChildren.length - expand;
    for (let j = expand; j < subChildren.length; j++) {
        const subChild = subChildren[j];
        if (subChild.sep) {
            remaining--;
        }
    }
    const showMoreButton = !all && remaining > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextTitleNested_1.ContextTitleNested, { key: child.id ?? child.name, icon: child.icon?.(), open: open && showMoreButton, onClick: () => state.select([...path, menu], child), renderPane: () => renderPane(child), onMouseEnter: onTitleMouseEnter, onMouseLeave: onTitleMouseLeave, onMouseMove: onTitleMouseMove }, child.display?.() ?? t(child.name)),
        nodes,
        showMoreButton && (React.createElement("div", { "data-menu-row": true },
            React.createElement(ContextItem_1.ContextItem, { compact: true, bg: true, more: true, inset: state.props.inset, 
                // icon={<Iconista style={{opacity: .5}} width={15} height={15} set={'radix'} icon={'dots-vertical'} />}
                // icon={<Iconista width={16} height={16} set={'elastic'} icon={'empty'} />}
                onClick: () => setAll(true), role: "menuitem", tabIndex: -1, icon: React.createElement(Flex_1.Flex, { style: { width: 16, height: 16, justifyContent: 'center', alignItems: 'end' } },
                    React.createElement(Iconista_1.Iconista, { width: 12, height: 12, set: 'radix', icon: 'arrow-down', style: { opacity: 0.7 } })) },
                React.createElement(Code_1.Code, { size: -1, gray: true, spacious: true, roundest: true },
                    "+",
                    remaining,
                    " ",
                    t('more')))))));
};
exports.ExpandSection = ExpandSection;
